<template>
    <DataTable :loading="!header" :value="dataArray" responsiveLayout="scroll"
        class="p-datatable-sm editable-cells-table" :rowClass="hideRow">
        <Column>
            <template #header="">
                <!-- <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addDetail"
                    :disabled="!canEdit" /> -->
            </template>
            <template #body="slotProps">
                <!-- <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteDetail(slotProps)"
                    :disabled="!canEdit" /> -->
            </template>
        </Column>
        <Column field="Role" :header="$t('role')" key="Role" class="w-1">
            <template #body="slotProps">
                <InputText name="Role" v-model="slotProps.data[slotProps.column.props.field]" type="text"
                    :placeholder="$t('role')" :disabled="true" @change="onCellEditComplete(slotProps)" />
            </template>
        </Column>
        <Column field="rolename" :header="$t('rolename')" key="rolename" class="w-2">
            <template #body="slotProps">
                <InputText name="rolename" v-model="slotProps.data[slotProps.column.props.field]" type="text"
                    :placeholder="$t('rolename')" :disabled="true" @change="onCellEditComplete(slotProps)" />
            </template>
        </Column>
        <Column field="tempArrMtc" :header="$t('approver')" key="tempArrMtc">
            <template #body="slotProps">
                <CustomMultiSelectV2 v-model="slotProps.data[slotProps.column.props.field]"
                    :url="$API_URL + 'list/userbycompany'" :minLength="0" :filter="true"
                    @change="onCellEditComplete(slotProps); changedept(slotProps, $event)"
                    placeholder="Please Select Approval" :disabled="!canEdit" :params="{ companyId: this.companyId }" />
            </template>
        </Column>
    </DataTable>
</template>
<script>
export default {
    props: {
        dataArray: {
            type: Array,
            default: []
        },
        dataModel: {
            type: Object,
            default: []
        },
        mode: {
            type: String,
            default: ""
        },
        header: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            companyId: this.$store.getters.getCompanyId
        }
    },
    methods: {
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetail() {
            var newDetail = this.dataModel;
            newDetail.mode = this.$FORM_MODE_CREATE;


            var det = { ...newDetail };


            this.dataArray.push(det);
        },
        deleteDetail(event) {
            if (event) {
                var detail = this.dataArray[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.dataArray.splice(this.dataArray.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {
            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.dataArray && this.dataArray.length > 0) {
                let m = this.dataArray[index].mode;
                if (m == this.$FORM_MODE_UNCHANGED) {
                    this.dataArray[index].mode = this.$FORM_MODE_EDIT;

                }
            }
        },
        companychange(event, e) {
            if (this.dataArray && this.dataArray.length > 0) {
                this.dataArray[event.index].ApproverId = [];
            }
        },
        changedept(event, e) {
            if (this.dataArray && this.dataArray.length > 0) {
                this.dataArray[event.index].tempArrMtc = e == null ? [] : e;
                this.dataArray[event.index].UserId = this.dataArray[event.index].tempArrMtc.map(a => a.id);
            }
        }
    },
    computed: {
        canEdit() {
            return this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT;
        }
    }
}
</script>